import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const getStateApi = async params => {
    const callResponse = await axios({
        url: endpoints.stateFetch,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const CreateStateApi = async data => {
    const callResponse = await axios({
        url: endpoints.Createstate,
        method: "post",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const DeleteStateApi = async data => {
    const callResponse = await axios({
        url: endpoints.Deletestate,
        method: "delete",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const UpdateStateApi = async data => {
    const callResponse = await axios({
        url: endpoints.Updatestate,
        method: "patch",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const StateFindByIdApi = async params => {
    const callResponse = await axios({
        url: endpoints.stateById,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};